import styled, { css } from 'styled-components'

import { Card } from '@/components/ui/card'
import { thinScrollbar } from '@/theme/common/scrollbar'

export const ScrollableCard = styled(Card)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  ${thinScrollbar}
`

export const Container = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.space['32']};
  `,
)

export const SettingsSection = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
  `,
)

export const SectionTitle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    white-space: nowrap;
  `,
)

export const SettingRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space['20']} 0;
  `,
)

export const TipInputsRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.space['12']};
    padding-bottom: ${theme.space['16']};
  `,
)

export const CashInputRow = styled.div(
  () => css`
    display: flex;
  `,
)

export const SettingLabel = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    white-space: nowrap;
  `,
)

export const DaysList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['12']};
  `,
)

export const DayRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['16']};
  `,
)

interface DayButtonProps {
  $isEnabled: boolean
}

export const DayButton = styled.button<DayButtonProps>(
  ({ theme, $isEnabled }) => css`
    width: 4rem;
    height: 4rem;
    border-radius: ${theme.border.radius.circle};
    border: ${theme.border.size['2']} solid
      ${$isEnabled ? theme.colors.black : theme.colors.black300};
    background-color: ${$isEnabled ? theme.colors.black : 'transparent'};
    color: ${$isEnabled ? theme.colors.white : theme.colors.black600};
    font-weight: 500;
    font-size: 1.2rem;
    cursor: pointer;
    transition: all ${theme.transition.duration.sm};
    flex-shrink: 0;

    &:hover:not(:disabled) {
      border-color: ${theme.colors.black};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `,
)

export const TimeInputs = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space['12']};
    flex: 1;

    > div {
      flex: 1;
    }
  `,
)

export const UnavailableText = styled.div(
  ({ theme }) => css`
    padding-left: ${theme.space['8']};
  `,
)

export const Footer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    gap: ${theme.space['12']};
    margin-top: auto;
  `,
)

export const GlobalTaxContainer = styled.div(
  ({ theme }) => css`
    padding: ${theme.space['8']} 0;
  `,
)
